<main class="esf-main-content esf-main-content--has-sidebar -has-transition" style="width: 100vw" [class.-is-open]="isOpened">
  <div class="esf-container main-content--full-screen" [class.full-screen-opened]="isOpened">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span class="esf-action-heading__text">
        <span i18n="@@tixxSelect.heading.eventAdministration">Event Administration</span>
        <a class="esf-tag" style="vertical-align: middle; margin-left: 10px;" [ngClass]="selectedLottery.status.statusCssClass">{{ selectedLottery.status.translatedCustomerStatus }}</a>
      </span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <button class="esf-button esf-button--outlined esf-button--standard esf-button--standard esf-button--small"
                  i18n="@@general.button.downloadTickets"
                  (click)="retrieveSubmittedTickets()">
            Download Tickets
          </button>
        </span>
        <span class="esf-action-heading__action">
          <button *ngIf="selectedLottery.status.value === activated"
                  class="esf-button esf-button--outlined esf-button--standard esf-button--standard esf-button--small"
                  i18n="@@general.button.editMode"
                  (click)="showEditModal()">
            Edit Mode
          </button>
        </span>
        <span class="esf-action-heading__action">
          <button class="esf-button esf-button--filled esf-button--standard esf-button--standard esf-button--small"
                  *ngIf="selectedLottery.isEditMode || selectedLottery.isDraftMode"
                  i18n="@@general.button.releaseEvent"
                  (click)="showReleaseModal()">
            Release Event
          </button>
          <button class="esf-button esf-button--filled esf-button--standard esf-button--standard esf-button--small"
                  *ngIf="selectedLottery.isActivated"
                  i18n="@@general.button.closeEvent"
                  (click)="showInternalModal()">
            Close Event
          </button>
          <button class="esf-button esf-button--filled esf-button--standard esf-button--standard esf-button--small"
                  *ngIf="selectedLottery.isInternalMode"
                  i18n="@@general.button.goToExecution"
                  (click)="showExecutionModal()">
            Go to execution
          </button>
          <button class="esf-button esf-button--filled esf-button--standard esf-button--standard esf-button--small"
                  *ngIf="selectedLottery.isExecutionMode"
                  i18n="@@general.button.completeEvent"
                  (click)="showCompletionModal()">
            Complete event
          </button>
        </span>
      </span>
    </h1>

    <div class="esf-info-tile-grid esf-info-tile-grid--3">
      <app-lottery-details-info
                                class="esf-info-tile-grid__item"
                                style="display: flex; flex-direction: column;"
                                [selectedLottery]="selectedLottery">
      </app-lottery-details-info>

      <app-process-configuration-info
                                      class="esf-info-tile-grid__item"
                                      style="display: flex; flex-direction: column;"
                                      [selectedLottery]="selectedLottery">
      </app-process-configuration-info>

      <app-webpage-individualization-info
                                          class="esf-info-tile-grid__item"
                                          style="display: flex; flex-direction: column;"
                                          [selectedLottery]="selectedLottery">
      </app-webpage-individualization-info>

      <app-ticket-quota-list class="esf-info-tile-grid__item"
                             style="display: flex; flex-direction: column;"
                             [selectedLottery]="selectedLottery">
      </app-ticket-quota-list>

      <app-optional-checkbox-info
                                  class="esf-info-tile-grid__item"
                                  style="display: flex; flex-direction: column;"
                                  [selectedLottery]="selectedLottery">
      </app-optional-checkbox-info>
    </div>

    <div class="esf-accordion esf-accordion--info-tiles">
      <app-price-reductions-list [selectedLottery]="selectedLottery" [(isPanelOpened)]="listOfPanels.priceReductions">
      </app-price-reductions-list>

      <app-price-categories-list [selectedLottery]="selectedLottery" [(isPanelOpened)]="listOfPanels.priceCategories">
      </app-price-categories-list>
    </div>

  </div>
</main>
